(function(){
  function syncStoryModal(modal){
    if(!modal) return;
    var shell = modal.querySelector('.lbx-story-v14__shell');
    if(shell){
      modal.style.setProperty('--lbx-story-visual-progress', '0');
      if(shell.scrollTop !== 0) shell.scrollTop = 0;
    }
  }

  function bindModalTriggers(){
    document.querySelectorAll('[data-lbx-story-readmore-open]').forEach(function(btn){
      if(btn.__lbx51Bound) return;
      btn.__lbx51Bound = true;
      btn.addEventListener('click', function(){
        setTimeout(function(){
          document.querySelectorAll('.lbx-story-v10__modal:not([hidden])').forEach(syncStoryModal);
        }, 30);
      });
    });
  }

  function apply(){
    bindModalTriggers();
    document.querySelectorAll('.lbx-story-v10__modal:not([hidden])').forEach(syncStoryModal);
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply); else apply();
  new MutationObserver(apply).observe(document.documentElement,{subtree:true,childList:true,attributes:true,attributeFilter:['hidden','aria-hidden']});
})();
